<template>
  <core-navigation
    :external-links="externalLinks"
    @route-change="setItemEditors"
  >
    <template v-slot:navbar-buttons>
      <!--Quick Access Buttons -->
    </template>
    <template v-slot:top-body-content>
      <!-- Global Items -->
    </template>
    <router-view />
  </core-navigation>
</template>

<script>
import AppCommon from './AppCommon'
import {CoreNavigation, apiHelpers, itemHelpers} from '@/ft-vue-core'

export default {
  name: 'App',
  components: {CoreNavigation},
  mixins: [apiHelpers, itemHelpers, AppCommon],
  data () {
    return {
    }
  },
  computed: {
    externalLinks () {
      return [
        ...this.externalLinksCommon,
        // {
        //   icon: 'mdi-email',
        //   text: 'Send Email to Members',
        //   parms: [{parm: 'send_email', value: 1}]
        // }
      ]
    }
  },
  watch: {
  },
  mounted () {
    console.warn('Mounted AppSupport')
    this.setItemEditors()
  },
  methods: {
    setItemEditors () {
    },
    /**
     * Called by Dialogs to check access for linking URLs in put request prompt callbacks
     * returning true allow doApiMessageLink to be called
     *
     * TODO:  Come up with better method for this
     */
    checkApiMessageLink (message, dialog) {
      switch (message.recordType) {
      // case 'DiningReservation':
      //   // User has access to view reservations.  Allow linking to reservations
      //   return this.$ftAccess.viewReservations || this.$ftAccess.manageReservations
      default:
        // Fall back to global handlers
        return this.checkApiMessageLinkCommon(message, dialog)
      }
    },
    /**
     * Called by Dialogs to generate App link URLs in put request prompt callbacks
     * Allows app te generate relative links to components based on ftAPI response data
     *
     * TODO:  Come up with better method for this
     */
    doApiMessageLink (message, dialog) {
      // var routeData
      switch (message.recordType) {
      // case 'DiningEvent':
      //   // Link to a list of events
      //   routeData = this.$router.resolve({path: '/events/upcoming', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
      //   window.open(routeData.href, '_blank')
      //   break
      default:
        // Fall back to global handlers
        this.doApiMessageLinkCommon(message, dialog)
      }
    }
  }
}
</script>
